var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _rect, _rect2, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiBusinessPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 75,
    viewBox: "0 0 363 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.338 37.4399H174.5L137.089 37.4399",
    stroke: "#485EB0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.186 37.4395L226.946 37.4395",
    stroke: "#485EB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.642 34.5595L226.946 37.4396L224.642 40.3196",
    stroke: "#485EB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.393 37.4395L133.633 37.4395",
    stroke: "#485EB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.937 34.5595L133.633 37.4396L135.937 40.3196",
    stroke: "#485EB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.902 17.5454H326.861V22.7494H327.902V17.5454Z",
    fill: "#664635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M348.866 17.5454H347.825V22.7494H348.866V17.5454Z",
    fill: "#664635"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.424 17.5454H307.383V22.7494H308.424V17.5454Z",
    fill: "#664635"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.609 62.002H234.23V73.5993H236.609V62.002Z",
    fill: "#967245"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.815 43.7188L234.973 45.1997L235.384 73.9077H249.313L245.815 43.7188Z",
    fill: "#967245"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.159 16.8489H267.06L261.285 28.595H290.159V16.8489Z",
    fill: "#C8DBD9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.198 16.8489H263.099L257.324 28.595H286.198V16.8489Z",
    fill: "#859997"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.984 18.2881H265.757L262.45 27.7504H278.984V18.2881Z",
    fill: "#485B59"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.467 22.2969H233.969L240.421 74.2532H345.345L349.467 22.2969Z",
    fill: "#DB9C6E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352.048 22.2969H236.543L242.996 74.2532H347.926L352.048 22.2969Z",
    fill: "#F4C49D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M349.609 25.3772L241.563 26.5667L246.048 73.777H345L349.609 25.3772Z",
    fill: "#A05A44"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M334.741 67.0568H334.17V73.7774H334.467V67.2412H345.625L345.654 66.9438H334.741V67.0568Z",
    fill: "#753827"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M319.504 67.0568V66.9438H305.04V67.0568H304.469V73.7774H304.766V67.2412H319.409V73.7774H319.706V67.0568H319.504Z",
    fill: "#753827"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.802 67.0568V66.9438H275.529V67.0568H274.952V73.7774H275.249V67.2412H289.897V73.7774H290.195V67.0568H289.802Z",
    fill: "#753827"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.285 67.0568V66.9438H245.827V67.0568H245.411L245.554 68.5496V67.2412H260.196V73.7774H260.494V67.0568H260.285Z",
    fill: "#753827"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M319.872 59.2893H319.504V59.5688H319.872V59.2893Z",
    fill: "#753827"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M334.443 59.5867V66.7592H319.801V59.8662H319.504V66.9436V67.0566H319.706H334.17H334.741V66.9436V59.2893H320.17V59.5867H334.443Z",
    fill: "#753827"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M319.688 52.0989H305.23V52.1167H304.933V59.2893H305.046V59.8662H319.504H319.801H320.17V59.5866V59.2893V52.1167H319.688V52.0989ZM319.872 52.3962V59.2952V59.5747H319.504H305.23V52.4022H319.872V52.3962Z",
    fill: "#753827"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M319.986 44.8314H319.688V52.099V52.1169H320.17H334.925V44.8314H334.628V51.8195H319.986V44.647H334.259V44.3496H319.986V44.8314Z",
    fill: "#753827"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M334.925 44.3496H334.557V44.534H334.925V44.3496Z",
    fill: "#753827"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M290.171 59.2893H289.802V59.5688H290.171V59.2893Z",
    fill: "#753827"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M305.04 59.2893H304.927H290.468V59.5867H304.742V66.7592H290.1V59.8662H289.802V66.9436V67.0566H290.195H304.469H305.04V66.9436V59.8662V59.2893Z",
    fill: "#753827"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M275.529 59.2893V59.8662H289.802H290.1H290.469V59.5866V59.2893V52.1167H289.987V52.0989H275.713V52.1167H275.231V59.2893H275.529ZM275.529 52.3962H290.171V59.2952V59.5747H289.802H275.529V52.3962Z",
    fill: "#753827"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.224 44.3496H305.04V44.534H305.224V44.3496Z",
    fill: "#753827"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M289.987 52.1169H290.469H304.927H305.23V52.099V44.8314H304.933V51.8195H290.284V44.647H304.742V44.3496H290.284V44.8314H289.987V52.099V52.1169Z",
    fill: "#753827"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.655 59.2893H260.286V59.5688H260.655V59.2893Z",
    fill: "#753827"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M275.529 59.2893H275.232H260.958V59.5867H275.232V66.7592H260.583V59.8662H260.286V66.9436V67.0566H260.494H274.952H275.529V66.9436V59.8662V59.2893Z",
    fill: "#753827"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M245.714 52.1167V59.2893H245.827V59.8662H260.286H260.583H260.952V59.5866V59.2893V52.1167H260.47V52.0989H246.012V52.1167H245.714ZM260.66 52.3962V59.2952V59.5747H260.292H246.018V52.4022H260.66V52.3962Z",
    fill: "#753827"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M275.713 44.3496H275.344V44.534H275.713V44.3496Z",
    fill: "#753827"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M260.958 52.1169H275.231H275.713V52.099V44.8314H275.416V51.8195H260.773V44.647H275.047V44.3496H260.476V52.099V52.1169H260.958Z",
    fill: "#753827"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245.828 66.9436V59.8662V59.2893H245.715H244.674L244.704 59.5867H245.53V66.7592H245.382L245.411 67.0566H245.828V66.9436Z",
    fill: "#753827"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M246.012 52.1169V52.099V44.3496H243.252L243.282 44.647H245.715V51.8195H243.966L243.99 52.1169H245.715H246.012Z",
    fill: "#753827"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M334.926 37.3616H348.468L348.497 37.0642H334.926V37.3616Z",
    fill: "#753827"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M334.628 37.0642H334.259V37.3437H334.628V37.0642Z",
    fill: "#753827"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M334.557 44.5337V44.3494V37.6348H334.259V44.3494V44.6467V44.8311H334.628H334.926H347.76L347.784 44.5337H334.926H334.557Z",
    fill: "#753827"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M319.986 37.0644V37.6413H334.259H334.557H334.925V37.3618V37.0644V29.8919H334.444V29.874H320.17V29.8919H319.688V37.0644H319.986ZM319.986 30.1654H334.628V37.0644V37.3439H334.259H319.986V30.1654Z",
    fill: "#753827"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M349.609 25.3774H349.383V27.7267L349.609 25.3774Z",
    fill: "#753827"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M334.443 29.892H334.925H349.181L349.211 29.5946H334.741V25.5444H334.443V29.8682V29.892Z",
    fill: "#753827"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M305.111 37.0642H304.742V37.3437H305.111V37.0642Z",
    fill: "#753827"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M304.742 44.6471V44.8315H304.933H305.23H319.688H319.985V44.3498V37.6352V37.0642H319.688H305.408V37.3616H319.688V44.5341H305.23H305.04V44.3498V37.6352H304.742V44.3498V44.6471Z",
    fill: "#753827"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M290.284 37.0644V37.6413H304.742H305.04H305.408V37.3618V37.0644V29.8919H304.927V29.874H290.469V29.8919H290.171V37.0644H290.284ZM290.469 30.1654H305.111V37.0644V37.3439H304.742H290.469V30.1654Z",
    fill: "#753827"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M304.927 29.8915H305.408H319.688H320.17V29.8678V25.7046H319.872V29.5942H305.224V25.8652L304.927 25.8711V29.8678V29.8915Z",
    fill: "#753827"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M275.047 44.8315H275.415H275.713H289.987H290.284V44.3498V37.6352V37.0642H290.171H275.713V37.3616H289.987V44.5341H275.713H275.344V44.3498V37.6352H275.047V44.3498V44.6471V44.8315Z",
    fill: "#753827"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M275.415 37.0642H275.047V37.3437H275.415V37.0642Z",
    fill: "#753827"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M275.713 37.6352V37.3557V37.0583V29.8858H275.231V29.8679H260.476V37.6352H275.047H275.344H275.713ZM260.773 37.3378V30.1653H275.416V37.0642V37.3438H275.047H260.773V37.3378Z",
    fill: "#753827"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M275.231 29.8913H275.713H290.171H290.469V29.8676V26.0315H290.171V29.594H275.529V26.1921L275.231 26.198V29.8676V29.8913Z",
    fill: "#753827"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M245.893 72.1414L246.048 73.7769H345L345.155 72.1414H245.893Z",
    fill: "#823B27"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M244.936 34.9406L241.563 26.5667L246.048 73.777H249.872L244.936 34.9406Z",
    fill: "#C66146"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M275.392 36.5708H257.413L259.048 65.4751H277.027L275.392 36.5708Z",
    fill: "#F4C49D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M274.732 37.3198H258.21L259.709 65.4747H276.237L274.732 37.3198Z",
    fill: "#345B59"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M273.804 37.9143H259.328L260.642 64.8797H275.118L273.804 37.9143Z",
    fill: "#72B2B1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M273.804 37.9143H269.908L259.851 48.6969L260.642 64.8797H264.538L274.589 54.1031L273.804 37.9143Z",
    fill: "#92CCC9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M275.362 59.0515H260.101V59.896H275.362V59.0515Z",
    fill: "#345B59"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M276.356 58.7185H259.013V59.3846H276.356V58.7185Z",
    fill: "#F4C49D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M275.362 56.4521H260.101V57.2967H275.362V56.4521Z",
    fill: "#345B59"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M276.356 56.1199H259.013V56.786H276.356V56.1199Z",
    fill: "#F4C49D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M275.737 61.728H260.476V62.5726H275.737V61.728Z",
    fill: "#345B59"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M276.724 61.3948H259.382V62.0609H276.724V61.3948Z",
    fill: "#F4C49D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M274.321 39.6511H259.06V40.4957H274.321V39.6511Z",
    fill: "#345B59"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M275.314 39.3181H257.972V39.9842H275.314V39.3181Z",
    fill: "#F4C49D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M341.283 36.2737H283.058V62.3946H339.499L341.283 36.2737Z",
    fill: "#F4C49D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M339.945 37.1716H284.396V61.4905H338.244L339.945 37.1716Z",
    fill: "#345B59"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M339.053 37.9143H285.288V60.7463H337.405L339.053 37.9143Z",
    fill: "#72B2B1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M316.899 60.7463L338.999 38.6399L339.053 37.9143H307.442L285.288 60.0743V60.7463H316.899Z",
    fill: "#92CCC9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M284.64 64.2913H244.781V74.2531H284.64V64.2913Z",
    fill: "#F4C49D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M300.674 70.9104H273.316V74.2588H300.674V70.9104Z",
    fill: "#F4C49D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M293.198 68.5378H276.034V71.8862H293.198V68.5378Z",
    fill: "#F4C49D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M241.664 26.5667L244.769 34.9406L336.953 34.8692L334.592 73.777H344.298L347.599 26.5667H241.664Z",
    fill: "#7C5959"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M277.574 53.824L276.159 54.5674V55.1621L277.574 54.4187V53.824Z",
    fill: "#F4C49D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M277.236 47.9536L275.713 47.4838L275.606 46.9128L277.129 47.3767L277.236 47.9536Z",
    fill: "#F4C49D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M277.176 47.3767L276.802 47.4838L277.2 54.2995L277.598 54.3946L277.176 47.3767Z",
    fill: "#F4C49D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M236.758 48.917H234.379V58.8789H236.758V48.917Z",
    fill: "#967245"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M286.751 71.1721V69.0013L278.954 69.0073V65.1177L241.367 65.1474L242.669 74.2707L268.653 74.2528L278.96 74.2469L293.561 74.235L293.555 71.1662L286.751 71.1721Z",
    fill: "#DB9C6E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M362.396 73.3018H231.554V74.7886H362.396V73.3018Z",
    fill: "#664635"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M255.998 42.9216H248.903L249.932 53.3295H257.027L255.998 42.9216Z",
    fill: "#823B27"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M256.098 42.4282H248.997L250.032 52.8361H257.127L256.098 42.4282Z",
    fill: "#C98D7D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M256.241 43.874L249.717 49.6787L250.032 52.8367H252.411L256.747 48.9828L256.241 43.874Z",
    fill: "#DDA89E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M291.124 37.5649L290.759 61.1558L291.151 61.1618L291.517 37.5709L291.124 37.5649Z",
    fill: "#345B59"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M304.307 37.5683L303.941 61.1592L304.334 61.1653L304.7 37.5744L304.307 37.5683Z",
    fill: "#345B59"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M319.275 37.5651L318.909 61.156L319.302 61.1621L319.667 37.5712L319.275 37.5651Z",
    fill: "#345B59"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M331.27 37.5644L330.904 61.1553L331.297 61.1614L331.662 37.5704L331.27 37.5644Z",
    fill: "#345B59"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M359.226 0H295.887V19.329H359.226V0Z",
    fill: "#ED9E37"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M353.624 0H319.825L301.483 19.329H335.288L353.624 0Z",
    fill: "#FFB448"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M310.048 13.9488C309.461 13.9488 308.891 13.8486 308.338 13.6481C307.785 13.4408 307.367 13.1954 307.083 12.912C307.021 12.8498 307.018 12.7876 307.073 12.7254L308.172 11.4293C308.213 11.374 308.258 11.3706 308.307 11.419C308.521 11.6125 308.784 11.7749 309.095 11.9063C309.406 12.0376 309.717 12.1033 310.028 12.1033C310.567 12.1033 310.836 11.9512 310.836 11.6471C310.836 11.5503 310.788 11.4743 310.691 11.419C310.601 11.3568 310.429 11.3084 310.173 11.2738L309.8 11.222C308.977 11.1045 308.358 10.8591 307.944 10.4858C307.529 10.1057 307.322 9.57346 307.322 8.88916C307.322 8.21869 307.571 7.67955 308.068 7.27174C308.566 6.85702 309.233 6.64966 310.069 6.64966C311.134 6.64966 312.022 6.91923 312.734 7.45837C312.803 7.49984 312.81 7.55859 312.755 7.63463L311.821 8.96174C311.78 9.01704 311.732 9.0274 311.676 8.99284C311.165 8.65415 310.657 8.48481 310.152 8.48481C309.751 8.48481 309.551 8.61268 309.551 8.86843C309.551 8.97211 309.599 9.05505 309.696 9.11726C309.8 9.17256 309.976 9.21749 310.225 9.25205L310.598 9.30389C311.441 9.42139 312.063 9.67023 312.464 10.0504C312.865 10.4236 313.066 10.9559 313.066 11.6471C313.066 12.3383 312.803 12.8947 312.278 13.3163C311.752 13.738 311.009 13.9488 310.048 13.9488Z",
    fill: "#FFF6B8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M317.7 13.8244H315.73C315.661 13.8244 315.627 13.7898 315.627 13.7207V8.76475C315.627 8.72327 315.606 8.70254 315.565 8.70254H313.895C313.826 8.70254 313.792 8.66798 313.792 8.59886V6.87776C313.792 6.80864 313.826 6.77408 313.895 6.77408H319.536C319.605 6.77408 319.639 6.80864 319.639 6.87776V8.59886C319.639 8.66798 319.605 8.70254 319.536 8.70254H317.866C317.825 8.70254 317.804 8.72327 317.804 8.76475V13.7207C317.804 13.7898 317.77 13.8244 317.7 13.8244Z",
    fill: "#FFF6B8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M325.246 13.503C324.762 13.8002 324.191 13.9488 323.535 13.9488C322.878 13.9488 322.304 13.8002 321.814 13.503C321.33 13.2057 320.995 12.7703 320.808 12.1966C320.663 11.7404 320.59 11.1079 320.59 10.2992C320.59 9.49051 320.663 8.85806 320.808 8.40186C320.995 7.82816 321.33 7.3927 321.814 7.09549C322.304 6.79827 322.878 6.64966 323.535 6.64966C324.191 6.64966 324.762 6.79827 325.246 7.09549C325.736 7.3927 326.075 7.82816 326.262 8.40186C326.407 8.86497 326.479 9.49742 326.479 10.2992C326.479 11.1079 326.407 11.7404 326.262 12.1966C326.075 12.7703 325.736 13.2057 325.246 13.503ZM322.871 11.5745C322.968 11.8717 323.189 12.0203 323.535 12.0203C323.88 12.0203 324.102 11.8717 324.198 11.5745C324.254 11.4017 324.281 10.9766 324.281 10.2992C324.281 9.62184 324.254 9.19675 324.198 9.02395C324.102 8.72673 323.88 8.57812 323.535 8.57812C323.189 8.57812 322.968 8.72673 322.871 9.02395C322.816 9.19675 322.788 9.62184 322.788 10.2992C322.788 10.9766 322.816 11.4017 322.871 11.5745Z",
    fill: "#FFF6B8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M333.638 13.8244H331.471C331.395 13.8244 331.344 13.7898 331.316 13.7207L330.414 11.5227H330.051C330.009 11.5227 329.989 11.5434 329.989 11.5849V13.7207C329.989 13.7898 329.954 13.8244 329.885 13.8244H327.926C327.856 13.8244 327.822 13.7898 327.822 13.7207V6.87776C327.822 6.80864 327.856 6.77408 327.926 6.77408H330.87C331.748 6.77408 332.418 6.9918 332.881 7.42726C333.351 7.86272 333.586 8.43642 333.586 9.14837C333.586 10.0538 333.234 10.7139 332.529 11.1287L333.711 13.7103C333.739 13.7864 333.714 13.8244 333.638 13.8244ZM330.704 9.78082C331.174 9.78082 331.409 9.58037 331.409 9.17947C331.409 8.77857 331.174 8.57812 330.704 8.57812H330.051C330.009 8.57812 329.989 8.59886 329.989 8.64033V9.71861C329.989 9.76008 330.009 9.78082 330.051 9.78082H330.704Z",
    fill: "#FFF6B8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M334.979 13.7207V6.87776C334.979 6.80864 335.014 6.77408 335.083 6.77408H339.8C339.869 6.77408 339.904 6.80864 339.904 6.87776V8.47444C339.904 8.54356 339.869 8.57812 339.8 8.57812H337.198C337.156 8.57812 337.136 8.59886 337.136 8.64033V9.32462C337.136 9.3661 337.156 9.38683 337.198 9.38683H339.282C339.351 9.38683 339.386 9.42139 339.386 9.49051V11.0457C339.386 11.1148 339.351 11.1494 339.282 11.1494H337.198C337.156 11.1494 337.136 11.1701 337.136 11.2116V11.9581C337.136 11.9996 337.156 12.0203 337.198 12.0203H339.8C339.869 12.0203 339.904 12.0549 339.904 12.124V13.7207C339.904 13.7898 339.869 13.8244 339.8 13.8244H335.083C335.014 13.8244 334.979 13.7898 334.979 13.7207Z",
    fill: "#FFF6B8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M344.354 13.7207V12.3314C344.354 12.2761 344.371 12.2277 344.406 12.1862L346.883 9.60456C347.118 9.36264 347.236 9.11035 347.236 8.84769C347.236 8.48826 347.077 8.30855 346.759 8.30855C346.42 8.30855 346.234 8.55393 346.199 9.04468C346.199 9.12072 346.161 9.15182 346.085 9.138L344.457 8.92027C344.395 8.91336 344.364 8.87534 344.364 8.80622C344.392 8.1634 344.637 7.64499 345.1 7.25101C345.57 6.85011 346.158 6.64966 346.863 6.64966C347.554 6.64966 348.124 6.84665 348.573 7.24064C349.023 7.63463 349.247 8.13921 349.247 8.75438C349.247 9.42485 348.967 10.0469 348.408 10.6206L346.956 12.1033V12.124H349.144C349.213 12.124 349.247 12.1586 349.247 12.2277V13.7207C349.247 13.7898 349.213 13.8244 349.144 13.8244H344.457C344.388 13.8244 344.354 13.7898 344.354 13.7207Z",
    fill: "#FFF6B8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9155 67.9155V70.3314H17.9909V71.8653H14.6995V74.2812H28.5236V72.9646H31.815V70.3314H37.7396V67.9155H23.9155Z",
    fill: "#FFEBBD"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4887 69.0156V71.0103H19.466V72.2808H16.6748V74.282H28.3924V73.1892H31.1835V71.0103H36.2063V69.0156H24.4887Z",
    fill: "#BCA377"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M119.256 11.8428H26.088L29.5506 73.7089H122.857L119.256 11.8428Z",
    fill: "#D6C9A7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8782 55.2106C48.8453 54.6774 48.4043 54.2429 47.8908 54.2429H28.8004C28.4054 54.2429 28.1026 54.5721 28.1289 54.9868L28.7938 66.836C28.8267 67.4351 29.3204 67.9156 29.8997 67.9156H48.8256C49.2469 67.9156 49.576 67.5601 49.5497 67.1191L48.8782 55.2106Z",
    fill: "#EFE2CB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8906 40.7289C47.8576 40.1957 47.4166 39.7612 46.9031 39.7612H27.8127C27.4177 39.7612 27.1149 40.0904 27.1412 40.5051L27.8061 52.3543C27.839 52.9534 28.3328 53.4339 28.912 53.4339H47.8379C48.2592 53.4339 48.5883 53.0785 48.562 52.6374L47.8906 40.7289Z",
    fill: "#EFE2CB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9033 26.4232C46.8703 25.89 46.4293 25.4556 45.9158 25.4556H26.8254C26.4304 25.4556 26.1276 25.7847 26.1539 26.1994L26.8188 38.0487C26.8517 38.6477 27.3454 39.1283 27.9247 39.1283H46.8506C47.2719 39.1283 47.601 38.7728 47.5747 38.3317L46.9033 26.4232Z",
    fill: "#EFE2CB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M119.809 23.2049L37.8517 22.8757L42.4597 68.4624L123.429 68.6269L119.809 23.2049Z",
    fill: "#605A4D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M130.71 68.7188H26.1734L25.0675 74.5512H132.099L130.71 68.7188Z",
    fill: "#DBC495"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M118.051 26.8848H41.2549L45.5403 66.7114H120.302L118.051 26.8848Z",
    fill: "#709B98"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M116.518 37.8518L44.7639 35.877L46.4162 66.1057H119.315L116.518 37.8518Z",
    fill: "#95C1BF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M49.648 58.0945H48.8383V62.1759H49.648V58.0945Z",
    fill: "#709B98"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0846 57.8904H47.4562V58.4565H53.0846V57.8904Z",
    fill: "#709B98"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0718 61.8333H47.9167V62.3006H54.0718V61.8333Z",
    fill: "#709B98"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9893 45.7581H47.1401V66.5008H47.9893V45.7581Z",
    fill: "#709B98"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1414 53.6509C60.1414 54.9543 61.142 56.0141 62.373 56.0141C63.604 56.0141 64.6046 54.9543 64.6046 53.6509C64.6046 52.3475 63.604 51.2876 62.373 51.2876C61.142 51.2876 60.1414 52.3475 60.1414 53.6509Z",
    fill: "#709B98"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2439 40.4458H69.1798V45.1855H77.2439V40.4458Z",
    fill: "#709B98"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M77.882 54.3286H76.8221V56.4483H77.882V54.3286Z",
    fill: "#709B98"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4853 54.6584H72.5763V56.9427H74.4853V54.6584Z",
    fill: "#709B98"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9693 51.8799H67.3762V55.9613H68.9693V51.8799Z",
    fill: "#709B98"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5622 54.1711H64.6178V56.9492H70.5622V54.1711Z",
    fill: "#709B98"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M114.398 34.5679H113.443V60.3728H114.398V34.5679Z",
    fill: "#709B98"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M109.836 39.6289H107.288V41.2615H109.836V39.6289Z",
    fill: "#709B98"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9923 51.0635H91.8971V58.252H96.9923V51.0635Z",
    fill: "#709B98"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M114.292 54.9866H113.759V56.132H114.292V54.9866Z",
    fill: "#709B98"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M109.836 54.8225H108.453V58.2522H109.836V54.8225Z",
    fill: "#709B98"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M111.955 51.0635H111.422V58.0874H111.955V51.0635Z",
    fill: "#709B98"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M106.755 48.9438H104.846V51.2281H106.755V48.9438Z",
    fill: "#709B98"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M108.453 50.5771H99.54V57.114H108.453V50.5771Z",
    fill: "#709B98"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M115.708 56.29H60.5824V66.5791H115.708V56.29Z",
    fill: "#709B98"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M116.702 55.856H58.6733V57.5939H116.702V55.856Z",
    fill: "#709B98"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M103.253 34.2969H102.97V56.5076H103.253V34.2969Z",
    fill: "#709B98"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0808 34.2969H90.7977V56.5076H91.0808V34.2969Z",
    fill: "#709B98"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4856 34.2969H74.2025V56.5076H74.4856V34.2969Z",
    fill: "#709B98"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0389 34.2969H64.7559V56.5076H65.0389V34.2969Z",
    fill: "#709B98"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M114.575 34.0806H61.0759V39.5246H114.575V34.0806Z",
    fill: "#709B98"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M115.365 47.3979H61.7146V48.2208H115.365V47.3979Z",
    fill: "#709B98"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0776 57.9761H52.3337L53.7359 62.2089H54.4732L53.0776 57.9761Z",
    fill: "#709B98"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9545 33.7373H55.3818L57.1921 66.5729H57.7648L55.9545 33.7373Z",
    fill: "#709B98"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6029 33.7373H83.0302L84.8405 66.5729H85.4132L83.6029 33.7373Z",
    fill: "#709B98"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M109.717 32.6448H109.138L110.948 65.4737H111.527L109.717 32.6448Z",
    fill: "#709B98"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.9158 66.9807L88.8692 27.3187L116.188 26.6604L94.6293 66.6516L45.9158 66.9807Z",
    fill: "#BAD8D6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6517 25.5093H65.8289L69.4495 68.1336H70.2723L66.6517 25.5093Z",
    fill: "#605A4D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9458 25.5093H95.1229L98.7435 68.1336H99.5664L95.9458 25.5093Z",
    fill: "#605A4D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0114 42.2424L69.338 42.0251L70.9837 55.7374L95.5643 52.4459L95.0114 42.2424Z",
    fill: "#709B98"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9583 39.748L69.5022 41.4464L71.1479 55.1652L95.7285 51.8737L94.9583 39.748Z",
    fill: "#FCE0DE"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.974 22.053H26.4965L26.8256 25.43C26.3055 25.6078 26.1344 25.8645 26.22 26.5557L26.3582 29.8735L120.138 29.9525L119.974 22.053Z",
    fill: "#7C5959"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M120.81 10.9141H22.0659L25.0414 24.6065H122.041L120.81 10.9141Z",
    fill: "#FFEBBD"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M122.91 4.98975H19.2091L22.3426 18.6822H124.2L122.91 4.98975Z",
    fill: "#DB6A53"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3114 14.9562C28.9674 14.9562 28.6336 14.8976 28.3099 14.7802C27.9862 14.6588 27.7413 14.5152 27.5754 14.3493C27.539 14.3128 27.537 14.2764 27.5694 14.24L28.2128 13.4813C28.237 13.4489 28.2633 13.4469 28.2917 13.4752C28.4171 13.5885 28.5709 13.6836 28.753 13.7605C28.9351 13.8374 29.1172 13.8758 29.2992 13.8758C29.6149 13.8758 29.7727 13.7868 29.7727 13.6087C29.7727 13.5521 29.7444 13.5076 29.6877 13.4752C29.6351 13.4388 29.5339 13.4105 29.3842 13.3902L29.1657 13.3599C28.6842 13.2911 28.322 13.1474 28.0792 12.9289C27.8364 12.7064 27.715 12.3948 27.715 11.9942C27.715 11.6017 27.8607 11.286 28.1521 11.0473C28.4434 10.8045 28.8339 10.6831 29.3235 10.6831C29.9467 10.6831 30.4667 10.8409 30.8835 11.1565C30.9239 11.1808 30.928 11.2152 30.8956 11.2597L30.3493 12.0367C30.325 12.069 30.2967 12.0751 30.2643 12.0549C29.9649 11.8566 29.6675 11.7575 29.3721 11.7575C29.1374 11.7575 29.02 11.8323 29.02 11.982C29.02 12.0427 29.0484 12.0913 29.105 12.1277C29.1657 12.1601 29.2689 12.1864 29.4146 12.2066L29.6331 12.237C30.1268 12.3058 30.4909 12.4514 30.7256 12.674C30.9603 12.8925 31.0777 13.2041 31.0777 13.6087C31.0777 14.0134 30.9239 14.3391 30.6164 14.586C30.3089 14.8328 29.8739 14.9562 29.3114 14.9562Z",
    fill: "#F9EFDE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9596 14.8834H32.8064C32.7659 14.8834 32.7457 14.8632 32.7457 14.8227V11.9213C32.7457 11.8971 32.7335 11.8849 32.7093 11.8849H31.732C31.6916 11.8849 31.6713 11.8647 31.6713 11.8242V10.8166C31.6713 10.7762 31.6916 10.7559 31.732 10.7559H35.034C35.0745 10.7559 35.0947 10.7762 35.0947 10.8166V11.8242C35.0947 11.8647 35.0745 11.8849 35.034 11.8849H34.0568C34.0325 11.8849 34.0203 11.8971 34.0203 11.9213V14.8227C34.0203 14.8632 34.0001 14.8834 33.9596 14.8834Z",
    fill: "#F9EFDE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5454 14.6952C38.2621 14.8692 37.9283 14.9562 37.5439 14.9562C37.1595 14.9562 36.8236 14.8692 36.5363 14.6952C36.253 14.5212 36.0568 14.2663 35.9475 13.9304C35.8625 13.6634 35.8201 13.2931 35.8201 12.8197C35.8201 12.3462 35.8625 11.976 35.9475 11.7089C36.0568 11.373 36.253 11.1181 36.5363 10.9441C36.8236 10.7701 37.1595 10.6831 37.5439 10.6831C37.9283 10.6831 38.2621 10.7701 38.5454 10.9441C38.8327 11.1181 39.031 11.373 39.1402 11.7089C39.2252 11.98 39.2677 12.3503 39.2677 12.8197C39.2677 13.2931 39.2252 13.6634 39.1402 13.9304C39.031 14.2663 38.8327 14.5212 38.5454 14.6952ZM37.1554 13.5663C37.2121 13.7403 37.3416 13.8273 37.5439 13.8273C37.7462 13.8273 37.8757 13.7403 37.9323 13.5663C37.9647 13.4651 37.9809 13.2162 37.9809 12.8197C37.9809 12.4231 37.9647 12.1742 37.9323 12.0731C37.8757 11.8991 37.7462 11.8121 37.5439 11.8121C37.3416 11.8121 37.2121 11.8991 37.1554 12.0731C37.123 12.1742 37.1069 12.4231 37.1069 12.8197C37.1069 13.2162 37.123 13.4651 37.1554 13.5663Z",
    fill: "#F9EFDE"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6274 14.8834H42.3588C42.3143 14.8834 42.284 14.8632 42.2678 14.8227L41.7397 13.5359H41.5273C41.503 13.5359 41.4908 13.548 41.4908 13.5723V14.8227C41.4908 14.8632 41.4706 14.8834 41.4301 14.8834H40.2829C40.2425 14.8834 40.2222 14.8632 40.2222 14.8227V10.8166C40.2222 10.7762 40.2425 10.7559 40.2829 10.7559H42.0068C42.5207 10.7559 42.9132 10.8834 43.1843 11.1383C43.4595 11.3933 43.597 11.7291 43.597 12.1459C43.597 12.676 43.3907 13.0625 42.9779 13.3053L43.6699 14.8166C43.6861 14.8611 43.6719 14.8834 43.6274 14.8834ZM41.9096 12.5162C42.1848 12.5162 42.3224 12.3988 42.3224 12.1641C42.3224 11.9294 42.1848 11.8121 41.9096 11.8121H41.5273C41.503 11.8121 41.4908 11.8242 41.4908 11.8485V12.4798C41.4908 12.504 41.503 12.5162 41.5273 12.5162H41.9096Z",
    fill: "#F9EFDE"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M44.581 14.8227V10.8166C44.581 10.7762 44.6012 10.7559 44.6417 10.7559H47.4034C47.4439 10.7559 47.4641 10.7762 47.4641 10.8166V11.7514C47.4641 11.7919 47.4439 11.8121 47.4034 11.8121H45.8799C45.8556 11.8121 45.8435 11.8242 45.8435 11.8485V12.2491C45.8435 12.2734 45.8556 12.2855 45.8799 12.2855H47.0999C47.1404 12.2855 47.1606 12.3058 47.1606 12.3462V13.2567C47.1606 13.2972 47.1404 13.3174 47.0999 13.3174H45.8799C45.8556 13.3174 45.8435 13.3295 45.8435 13.3538V13.7908C45.8435 13.8151 45.8556 13.8273 45.8799 13.8273H47.4034C47.4439 13.8273 47.4641 13.8475 47.4641 13.888V14.8227C47.4641 14.8632 47.4439 14.8834 47.4034 14.8834H44.6417C44.6012 14.8834 44.581 14.8632 44.581 14.8227Z",
    fill: "#F9EFDE"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4382 14.8227V12.0306H51.426L50.6916 12.5101C50.6714 12.5222 50.6531 12.5263 50.637 12.5222C50.6208 12.5142 50.6127 12.498 50.6127 12.4737V11.4236C50.6127 11.3912 50.6268 11.3629 50.6552 11.3386L51.4442 10.7924C51.4807 10.7681 51.5191 10.7559 51.5596 10.7559H52.5914C52.6319 10.7559 52.6521 10.7762 52.6521 10.8166V14.8227C52.6521 14.8632 52.6319 14.8834 52.5914 14.8834H51.4989C51.4584 14.8834 51.4382 14.8632 51.4382 14.8227Z",
    fill: "#F9EFDE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M130.71 68.7188H26.1734L25.0675 74.5512H132.099L130.71 68.7188Z",
    fill: "#DBC495"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.026 70.0353L130.71 68.7188H26.1736L25.9235 70.0353H131.026Z",
    fill: "#FFEBBD"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M142.685 73.5645H0V74.881H142.685V73.5645Z",
    fill: "#5E533E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M122.679 24.6858H22.4808L23.205 22.0527L123.923 20.374L122.679 24.6858Z",
    fill: "#E0C48C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M124.088 4.60815H18.5969V6.7476H124.088V4.60815Z",
    fill: "#FFEBBD"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2024 4.60815H24.4424V6.7476H30.2024V4.60815Z",
    fill: "#F99180"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M118.084 4.60815H112.324V6.7476H118.084V4.60815Z",
    fill: "#F99180"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M100.501 4.60815H94.7411V6.7476H100.501V4.60815Z",
    fill: "#F99180"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9316 4.60815H77.1715V6.7476H82.9316V4.60815Z",
    fill: "#F99180"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3487 4.60815H59.5886V6.7476H65.3487V4.60815Z",
    fill: "#F99180"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7788 4.60815H42.0188V6.7476H47.7788V4.60815Z",
    fill: "#F99180"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3206 54.8027C73.3206 54.8027 94.4714 52.4132 96.2817 49.2073C96.6701 50.6358 96.8149 51.0176 95.7354 51.8668L73.3206 54.8027Z",
    fill: "#E8C2C1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M73.353 46.7519L73.2082 45.4617C73.1555 45.0141 73.4452 44.6652 73.906 44.6125L77.2962 44.2373L77.3817 44.9877L77.1645 45.8106L75.2489 46.0212L75.2818 46.2977L77.0987 47.2193C77.5595 47.4497 77.6846 47.7131 77.7372 48.2002L77.8886 49.5958C77.9413 50.0434 77.6516 50.3923 77.1974 50.445L73.8006 50.8202L73.6295 49.2864L75.8479 49.0428L75.8019 48.6412L73.985 47.7262C73.5308 47.4893 73.4057 47.2391 73.353 46.7519Z",
    fill: "#995247"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7723 43.7434L83.2403 49.0163L83.3259 49.7799L81.3708 49.9972L81.1206 48.7727L80.2649 48.8649L80.278 50.1157L78.3361 50.3329L78.2505 49.5693L78.527 44.1055L81.7723 43.7434ZM80.8112 47.2521L80.4294 45.4484L80.2122 45.4747L80.2385 47.3179L80.8112 47.2521Z",
    fill: "#995247"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M83.188 43.5849L85.13 43.3677L85.6368 47.9625L87.5985 47.7453L87.7697 49.2791L83.866 49.7136L83.188 43.5849Z",
    fill: "#995247"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2172 49.2335L87.5392 43.1049L91.7127 42.644L91.7983 43.4077L91.5745 44.224L89.6589 44.4346L89.7313 45.1192L91.6469 44.9086L91.8181 46.4424L89.9024 46.6531L89.9946 47.4956L92.2262 47.2455L92.3974 48.7793L88.2172 49.2335Z",
    fill: "#995247"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M121.948 12.9685H65.0062V13.6268H121.948V12.9685Z",
    fill: "#F9EFDE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178 54H176V64H182V54H180V57C180 57.5523 179.552 58 179 58C178.448 58 178 57.5523 178 57V54Z",
    fill: "url(#paint0_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 23,
    width: 52,
    height: 32,
    rx: 1,
    fill: "#2A2A2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 25,
    width: 48,
    height: 28,
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.85 62.2C168.944 62.0741 169.093 62 169.25 62H188.75C188.907 62 189.056 62.0741 189.15 62.2L189.9 63.2C190.147 63.5296 189.912 64 189.5 64H168.5C168.088 64 167.853 63.5296 168.1 63.2L168.85 62.2Z",
    fill: "url(#paint1_radial)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 64.5H188.533L189.5 64H168.5L169.5 64.5Z",
    fill: "#282828"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M208.856 66.3069L197.282 66.335C196.144 66.3377 195.214 65.4052 195.216 64.2629L195.262 38.7353C195.264 37.5926 196.198 36.656 197.336 36.6529L208.91 36.6248C210.048 36.6222 210.978 37.5542 210.976 38.6969L210.929 64.2245C210.927 65.3668 209.995 66.3038 208.856 66.3069Z",
    fill: "#252525"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M210.305 39.0559L210.26 63.9913C210.259 64.8372 209.573 65.5307 208.736 65.5331L197.624 65.5601C196.787 65.562 196.104 64.8718 196.105 64.0258L196.15 39.0905C196.152 38.2445 196.838 37.5511 197.674 37.5491L208.787 37.5217C209.623 37.5197 210.307 38.21 210.305 39.0559Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M205.436 38.313L200.783 38.3236C200.404 38.3243 200.094 38.0137 200.095 37.6329L200.095 37.5241C200.096 37.1438 200.406 36.8317 200.785 36.831L205.438 36.8204C205.817 36.8196 206.126 37.1302 206.126 37.511L206.126 37.6198C206.125 38.0001 205.814 38.3122 205.436 38.313Z",
    fill: "#252525"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M203.882 50.8298L202.908 54.2431C202.869 54.3788 202.729 54.4573 202.593 54.4182C202.551 54.406 202.512 54.3826 202.481 54.3503L199.971 51.7461C199.873 51.6448 199.875 51.4829 199.976 51.3847C200.009 51.3525 200.051 51.3298 200.096 51.3194L203.58 50.5102C203.717 50.4785 203.854 50.5641 203.885 50.7017C203.895 50.7439 203.894 50.788 203.882 50.8298Z",
    fill: "#FF9C60"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M206.23 48.5771L204.749 53.7617C204.71 53.8973 204.569 53.9758 204.434 53.9369C204.391 53.9245 204.352 53.9011 204.321 53.8688L200.51 49.9152C200.413 49.8139 200.415 49.652 200.516 49.5538C200.549 49.5216 200.591 49.4991 200.636 49.4885L205.928 48.2575C206.065 48.2256 206.202 48.3112 206.233 48.4488C206.243 48.491 206.242 48.5353 206.23 48.5771Z",
    fill: "#DB631A"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M203.322 52.8353L201.549 50.9722L203.574 50.5071C203.711 50.4758 203.848 50.5617 203.879 50.6993C203.889 50.7408 203.888 50.7838 203.876 50.8246L203.322 52.8353Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M179.603 37.6789L178.629 41.0922C178.591 41.228 178.45 41.3064 178.315 41.2673C178.272 41.2551 178.233 41.2317 178.202 41.1994L175.692 38.5952C175.594 38.4939 175.596 38.332 175.697 38.2338C175.731 38.2016 175.772 38.1789 175.817 38.1685L179.301 37.3593C179.438 37.3276 179.575 37.4132 179.607 37.5508C179.616 37.593 179.615 37.6371 179.603 37.6789Z",
    fill: "#FF9C60"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M181.951 35.4259L180.47 40.6106C180.431 40.7462 180.29 40.8247 180.155 40.7858C180.112 40.7733 180.073 40.75 180.042 40.7177L176.231 36.7641C176.134 36.6628 176.136 36.5009 176.237 36.4027C176.27 36.3705 176.312 36.348 176.357 36.3374L181.649 35.1064C181.786 35.0745 181.923 35.1601 181.954 35.2976C181.964 35.3399 181.963 35.3842 181.951 35.4259Z",
    fill: "#DB631A"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M179.043 39.6839L177.27 37.8209L179.295 37.3557C179.432 37.3244 179.569 37.4104 179.6 37.5479C179.61 37.5895 179.609 37.6324 179.597 37.6733L179.043 39.6839Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 179,
    y1: 54,
    x2: 179,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.25 63) rotate(90) scale(1 11.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D7D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBusinessPlaceholder);
export default __webpack_public_path__ + "static/media/multi-business-placeholder.1b268a42d7c0d06721a2db78ced426c8.svg";
export { ForwardRef as ReactComponent };